export class KaskoProceed {
  constructor(
    private _coverCareProceed: number = null,
    private _geniusProceed: number = null,
    private _shopProceed: number = null,
    private _agentProceed: number = null,
    private _mshpProceed: number = null
  ) { }

  get coverCareProceed(): number {
    return this._coverCareProceed;
  }

  get geniusProceed(): number {
    return this._geniusProceed;
  }

  get shopProceed(): number {
    return this._shopProceed;
  }

  get agentProceed(): number {
    return this._agentProceed;
  }

  get mshpProceed(): number {
    return this._mshpProceed;
  }

  static fromRaw(data: any): KaskoProceed {
    return new KaskoProceed(
      data.cover_care_proceed,
      data.genius_proceed,
      data.shop_proceed,
      data.agent_proceed,
      data.mshp_proceed
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/core/model/kasko-proceed.ts